<div id="faq" class="page-layout simple full-width">

    <!-- HEADER -->
    <div class="header accent p-16 p-sm-24" fxLayout="column" fxLayoutAlign="center center">

        <div class="hero-text mb-32">
            <h1>{{ 'How can we help?' | translate }}</h1>
            <h3>{{ 'Frequently asked questions' | translate }}</h3>
        </div>

    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content p-24">

        <div fxLayout="row wrap" fxLayoutAlign="center">
            <ng-container *ngFor="let group of faqs">
                <mat-nav-list class="answers-list" *ngIf="group.languages.indexOf(lang) > -1">
                    <h3 mat-subheader>{{group.group | translate}}</h3>
                    <div *ngFor="let qa of group.questions">
                        <a mat-list-item *ngIf="qa.lang === lang"
                        (click)="readAnswer(qa)">
                            {{ qa.question }}
                        </a>
                    </div>
                </mat-nav-list>
            </ng-container>
        </div>

    </div>
    <!-- / CONTENT -->

</div>
